<template>
    <div>
        <v-row class="fill-height ma-0">
            <!-- <v-btn @click="yes = true">
                click
            </v-btn> -->
            <v-col cols="4" style="height: 170px">
                <v-card height="170" width="" class="rounded-lg">
                    <v-card-text>
                        <v-row justify="center" >
                            <v-col cols="auto" align-self="start" class="">
                                <!-- <div> -->
                                    <v-img src="../../assets/Vectors/photo_2024-06-06_18-25-00.jpg" width="80" height="80" class="rounded-circle"></v-img>
                                <!-- </div> -->
                            </v-col>
                            <v-col cols="auto" class="" style="height: 170" align-self="center">
                                <!-- <div class="text-center"> -->
                                    <h3 class="text--color">Rasha Kutmawi</h3>
                                    <p class="mb-0"> Front-end Developer </p>
                                    <p class="mb-0"> 10-01-2023 </p>
                                <!-- </div> -->
                         
                                <!-- <v-col> -->
                                <v-row> 
                                    <v-col class="" align-self="end">
                                        <h5> Leave Balance </h5>
                                        <div class=" d-flex">
                                            <div 
                                                style="
                                                    
                                                " 						
                                                class="text-center align-center rounded-lg"
                                            > 
                                                <span style="font-weight: bold; font-size: 20px"> 12 </span> / 14
                                            </div> 
                                        </div>
                                    </v-col>    
                                </v-row>
                                <!-- </v-col> -->
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
    
            <v-col cols="4" style="height: 170px">
                <v-card height="170" width="" class="rounded-lg"> 
                    <v-card-text>
                       
                        <v-row>
                            <v-col>
                                <h5>Active project</h5>
                                <v-divider  class="my-1 me-5"/>
                                <div class="d-flex pb-2 pt-1">
                                    <div>
                                        <v-img src="../../assets/Vectors/pos.png" width="20" />
                                    </div>
                                    <span class="Urbanist-font ms-2"> POS </span>
                                </div>
    
                                <div class="d-flex pb-2">
                                    <div>
                                        <v-img src="../../assets/Vectors/OctopharmaLogo.png" width="20" />
                                    </div>
                                    <span class="Urbanist-font ms-2"> Octopharma </span>
                                </div>
    
                                <div class="d-flex pb-2">
                                    <div>
                                        <v-img src="../../assets/logo_black_notitle.png" width="27" />
                                    </div>
                                    <span class="Urbanist-font ms-2"> Bee tasking </span>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>   
            </v-col>
    
            <v-col cols="4" style="height: 170px">
                <v-card height="170" width="" class="rounded-lg"> 
                    <v-card-text>
                        <h5>Top 3 ..</h5>
                        <v-divider  class="my-1 me-5"/>
    
                        <div class="d-flex align-center">
                            <div>
                                <v-img  src="../../assets/Vectors/male.jpg" width="35" />
                            </div>
                            <span class="Urbanist-font ps-1"> Mohammad Fayad Dagher </span>
                        </div>
                        <div class="d-flex align-center">
                            <div>
                                <v-img  src="../../assets/Vectors/male.jpg" width="35" />
                            </div>
                            <span class="Urbanist-font ps-1"> Amany al edo </span>
                        </div>
    
                        <div class="d-flex align-center">
                            <div>
                                <v-img  src="../../assets/Vectors/male.jpg" width="35" />
                            </div>
                            <span class="Urbanist-font ps-1"> Abdalwahab Kakah </span>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="mx-0">
            <v-col cols="6" style="height: 300px">
                <v-card height="300px" width="" class="rounded-lg"> 
                    <v-card-text>
                        <v-card class="bg-secondary rounded-lg">
                            <v-card-title class="pb-0">
                                <v-row>
                                    <v-col cols="4" class="pa-1">
                                        <v-icon large color="primary">mdi-alert-circle-outline </v-icon>
                                        <span class="mb-0 ms-1 primary--text">Waring</span>
                                    </v-col>
                                    <v-col class="pa-1">
                                        <span class="" style="font-size: 15px"> You need more </span> 
                                        <span class="alert-color--text fw-bolder" style="font-size: 15px"> 3 hours </span>
                                    </v-col>
                                </v-row>
                            </v-card-title>

                            <v-card-text>
                                
                            </v-card-text>
                        </v-card>
                        <h4 class="mt-2"> Work hours </h4>
                        <bar-chart
                            type="bar"
                            height='225'
                            width='100%'
                            :series='seriesMonths'
                            :categories="months"
                        ></bar-chart>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="6" style="height: 300px">
                <v-card height="300px" class="rounded-lg">
                    <v-card-text>
                        <h4 class="mt-2"> Planning accuracy </h4>
                        <bar-chart
                            type="line"
                            height='225'
                            width='100%'
                            :series='seriesPlan'
                            :categories="PlanningAccuracy"
                        ></bar-chart>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import BarChart from '@/components/BarChart.vue'
export default {
	components: {
		BarChart
	},
	data () {
		return {
			seriesMonths: [
				{
					name: 'inf',
					data: ['2', '4', '6', '7']
				}
			],
			months: [
				'January ',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December'
			],
			// yes: false,
			seriesPlan: [
				{
					name: 'inf',
					data: ['20', '40', '60', '80', '100']
				}
			],
			PlanningAccuracy: [
				'The first week',
				'second week',
				'the third week',
				'fourth week'
			]
		}
	}
}
</script>

<style scoped>
.bg-secondary {
    background-color: #FBF4DA;
    /* box-shadow:  */
    box-shadow: 3px 0px 9px -4px #25252521
}
</style>
